var form_site_wide = function () {
  var handleConditionTypeChange = function () {
    $(".website-condition-setting").hide();
    var selected = $(this).val();

    if (selected == "If page is" || selected == "If page is NOT") {
      $('.website-condition-setting[data-type="url"]').show();
    }

    if (
      selected == "If URL contains" ||
      selected == "If URL does NOT contain"
    ) {
      $('.website-condition-setting[data-type="keyword"]').show();
    }

    if (selected == "If device type is") {
      $('.website-condition-setting[data-type="device"]').show();
    }

    if (
      selected == "If visiting from region" ||
      selected == "If NOT visiting from region"
    ) {
      $('.website-condition-setting[data-type="keyword"]').show();
    }

    if (
      selected == "If visiting from country" ||
      selected == "If NOT visiting from country"
    ) {
      $('.website-condition-setting[data-type="country"]').show();
    }

    if (
      selected == "If in custom segment" ||
      selected == "If NOT in custom segment"
    ) {
      $('.website-condition-setting[data-type="segment"]').show();
    }
  };

  $('#form_site_wide select[name="condition[condition_type]"]').on(
    "change",
    handleConditionTypeChange
  );

  // Initialize on page load
  $('#form_site_wide select[name="condition[condition_type]"]').each(
    handleConditionTypeChange
  );
};

export default form_site_wide;
